// istanbul ignore file

type OptOutAcpResponse = {
    redirectUrl: string;
};

enum Role {
    Master = 'MASTER'
}

type BasicUserDetails = {
    id: number;
    name: string;
    email: string;
};

export {
    OptOutAcpResponse,
    Role,
    BasicUserDetails,
};
